import { map } from 'lodash';
import { CheckboxGroup } from '@client/components/forms/CheckboxGroup';
import { Checkbox } from '@client/components/forms/Checkbox';
import { useSelector } from '@client/hooks/redux.hooks';
import { getVenueTypes } from '@client/selectors/entities/categories';

export const VenueTypes = () => {
  const venueTypes = useSelector(getVenueTypes);

  return (
    <CheckboxGroup
      name="venueType"
      label="Space type"
    >
      {map(venueTypes, (venueType) => (
        <Checkbox
          key={venueType.id}
          value={venueType.id}
          margin="dense"
        >
          {venueType.lang.label}
        </Checkbox>
      ))}
    </CheckboxGroup>
  );
};
